"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const react_1 = require("react");
const Mui_1 = require("../Mui");
exports.Image = (0, react_1.forwardRef)((props, ref) => {
    const { sx, width, height, ...boxProps } = props;
    return ((0, jsx_runtime_1.jsx)(Box_1.default, { component: "img", ...boxProps, ref: ref, sx: (0, Mui_1.mergeSxProps)({
            /**
             * Box does not pass `width` and `height` through.
             * Instead, pass it in via `sx`
             */
            width,
            height,
        }, sx) }));
});
exports.Image.displayName = "Image";
//# sourceMappingURL=Image.js.map